<div class="maint-container mat-elevation-z2">
  <div class="header">
    <h2>Vehicle Maintenance</h2>
    <div class="actions">
      <button mat-flat-button color="primary" (click)="runCheck()">Run Check</button>
      <button mat-flat-button color="accent" (click)="addRecord()">Add Service/Repair</button>
      <button mat-stroked-button color="accent" (click)="resetFilters()">Reset Filters</button>
    </div>
  </div>

  <div class="kpi-grid">
    <div class="kpi-card">
      <div class="kpi-title">Total Vehicles</div>
      <div class="kpi-value">{{ totalVehicles }}</div>
    </div>

    <div class="kpi-card warn">
      <div class="kpi-title">Needs Maintenance</div>
      <div class="kpi-value">{{ needsCount }}</div>
    </div>

    <div class="kpi-card">
      <div class="kpi-title">Avg. Days Since Service</div>
      <div class="kpi-value">{{ avgDays }}</div>
    </div>
  </div>

  <div class="kpi-grid" *ngIf="analytics">
    <div class="kpi-card">
      <div class="kpi-title">Total Records</div>
      <div class="kpi-value">{{ analytics.totalRecords }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-title">Service Count</div>
      <div class="kpi-value">{{ analytics.serviceCount }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-title">Repair Count</div>
      <div class="kpi-value">{{ analytics.repairCount }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-title">Total Cost</div>
      <div class="kpi-value">₦{{ analytics.totalCost | number }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-title">This Month Cost</div>
      <div class="kpi-value">₦{{ analytics.thisMonthCost | number }}</div>
    </div>
  </div>

  <div class="filters">
    <mat-form-field appearance="outline" class="search">
      <mat-label>Search by plate/model</mat-label>
      <input matInput (keyup)="applyTextFilter($event)" placeholder="e.g. KJA-123AB / Hiace" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="status">
      <mat-label>Status</mat-label>
      <mat-select [value]="status" (selectionChange)="applyStatusFilter($event.value)">
        <mat-option value="all">All</mat-option>
        <mat-option value="needs">Needs Maintenance</mat-option>
        <mat-option value="ok">OK</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="table-scroll">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1 full-width-table">
      <ng-container matColumnDef="vehiclePlate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Plate</th>
        <td mat-cell *matCellDef="let r">{{ r.vehiclePlate }}</td>
      </ng-container>

      <ng-container matColumnDef="model">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Model</th>
        <td mat-cell *matCellDef="let r">{{ r.model }}</td>
      </ng-container>

      <ng-container matColumnDef="totalDistance">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Distance (30d)</th>
        <td mat-cell *matCellDef="let r">{{ formatDistance(r.totalDistanceKm) }}</td>
      </ng-container>

      <ng-container matColumnDef="totalDeliveries">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Deliveries</th>
        <td mat-cell *matCellDef="let r">{{ r.totalDeliveries }}</td>
      </ng-container>

      <ng-container matColumnDef="daysSinceLastMaintenance">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Days Since</th>
        <td mat-cell *matCellDef="let r">{{ r.daysSinceLastMaintenance }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let r">
          <span class="chip" [class.chip-warn]="r.needsMaintenance" [class.chip-ok]="!r.needsMaintenance">
            {{ r.needsMaintenance ? 'Needs Maintenance' : 'OK' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="trend">
        <th mat-header-cell *matHeaderCellDef>Days Visual</th>
        <td mat-cell *matCellDef="let r">
          <div class="bar">
            <div class="bar-fill" [style.width]="barWidth(r.daysSinceLastMaintenance)"></div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="lastMaintenanceDate">
        <th mat-header-cell *matHeaderCellDef>Last Service</th>
        <td mat-cell *matCellDef="let r">{{ r.lastMaintenanceDate | date:'mediumDate' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let r">
          <button mat-button color="primary" (click)="markAsMaintained(r)" [disabled]="!r.needsMaintenance">
            Mark Done
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="data-row" *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <h3 class="records-title">Recent Service/Repair Records</h3>
  <div class="table-scroll">
    <table mat-table [dataSource]="recordsSource" class="mat-elevation-z1 full-width-table">
      <ng-container matColumnDef="vehiclePlate">
        <th mat-header-cell *matHeaderCellDef>Plate</th>
        <td mat-cell *matCellDef="let r">{{ r.vehiclePlate }}</td>
      </ng-container>
      <ng-container matColumnDef="recordType">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let r">{{ r.recordType }}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let r">{{ r.description }}</td>
      </ng-container>
      <ng-container matColumnDef="cost">
        <th mat-header-cell *matHeaderCellDef>Cost</th>
        <td mat-cell *matCellDef="let r">₦{{ r.cost | number }}</td>
      </ng-container>
      <ng-container matColumnDef="serviceDate">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let r">{{ r.serviceDate | date:'mediumDate' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="recordsColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: recordsColumns"></tr>
    </table>
  </div>

  <h3 class="records-title">Recent Meter & Fuel Logs</h3>
  <div class="table-scroll">
    <table mat-table [dataSource]="meterLogs" class="mat-elevation-z1 full-width-table">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let m">{{ m.workDate | date:'mediumDate' }}</td>
      </ng-container>
      <ng-container matColumnDef="plate">
        <th mat-header-cell *matHeaderCellDef>Plate</th>
        <td mat-cell *matCellDef="let m">{{ m.plateNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="meters">
        <th mat-header-cell *matHeaderCellDef>Meter</th>
        <td mat-cell *matCellDef="let m">{{ m.startMeter || '—' }} → {{ m.endMeter || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="distance">
        <th mat-header-cell *matHeaderCellDef>Distance</th>
        <td mat-cell *matCellDef="let m">{{ formatDistance(m.distance) }}</td>
      </ng-container>
      <ng-container matColumnDef="fuel">
        <th mat-header-cell *matHeaderCellDef>Fuel</th>
        <td mat-cell *matCellDef="let m">{{ m.startFuelLevel || '—' }} → {{ m.endFuelLevel || '—' }} (used {{ m.fuelUsed || 0 }})</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['date','plate','meters','distance','fuel']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['date','plate','meters','distance','fuel']"></tr>
    </table>
  </div>

  <h3 class="records-title">Recent Phone Logs</h3>
  <div class="table-scroll">
    <table mat-table [dataSource]="phoneLogs" class="mat-elevation-z1 full-width-table">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let p">{{ p.workDate | date:'mediumDate' }}</td>
      </ng-container>
      <ng-container matColumnDef="rider">
        <th mat-header-cell *matHeaderCellDef>Rider</th>
        <td mat-cell *matCellDef="let p">{{ p.riderName }}</td>
      </ng-container>
      <ng-container matColumnDef="credit">
        <th mat-header-cell *matHeaderCellDef>Credit</th>
        <td mat-cell *matCellDef="let p">{{ p.startCreditAmount || 0 }} → {{ p.endCreditAmount || '—' }} (used {{ p.creditUsed || 0 }})</td>
      </ng-container>
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef>State</th>
        <td mat-cell *matCellDef="let p">{{ p.startPhoneState || '—' }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['date','rider','credit','state']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['date','rider','credit','state']"></tr>
    </table>
  </div>
</div>
